import { PeriodMode } from '../../../../../../../../../enums/periodMode'
import type { PeriodValue } from '../../../../../../../../../types/periodValue'

export const isFinitePeriod = (periodValue: PeriodValue | undefined): periodValue is PeriodValue => {
  if (!periodValue || periodValue.mode === PeriodMode.All) {
    return false
  }

  if (periodValue.mode === PeriodMode.CustomDate) {
    return Boolean(periodValue.customDate?.startDate) && Boolean(periodValue.customDate?.endDate)
  }

  return true
}
